<template>
    <div class="d-flex justify-center align-center" :class="className">
        <svg v-svg="'icon-timer'" size="37" class="mr-2" fill="currentColor"></svg>
        <span :class="className">{{minute}}:{{`${second}`.length === 1 ? `0${second}`:second}}</span>
    </div>
</template>

<script>
    export default {
        props: ['minutes'],
        data(){
            return {
                minute: this.minutes,
                second: 0,
                interval: null,
                className: 'start',
                time_spent: 0,
            }
        },

        mounted() {
            this.initTimer();
        },

        watch: {
            'minutes' : function (newVal) {
                this.second = 0;
                this.minute = newVal;
                this.time_spent = 0;
                clearInterval(this.interval);
                this.initTimer();
            }
        },

        methods: {
            stopTimer() {
                clearInterval(this.interval);
                this.second = 0;
                this.minute = 0;
                this.time_spent = 0;
            },

            initTimer() {
                this.interval = setInterval(() => {
                    if(this.second === 0) {
                        this.minute--;
                        this.second = 0;
                    }

                    this.second = this.second === 0 ? 59 : this.second - 1;

                    if(this.second === 0 && this.minute === 1) this.className = 'middle';
                    if(this.second <= 30 && this.minute === 0) this.className = 'finish';

                    if(this.second === 0 && this.minute === 0) this.$emit('timeout');
                    this.time_spent++;
                }, 1000);
            }
        }
    }
</script>

<style scoped>
    .start, .middle, .finish{
        font-size: 30px;
        font-weight: bold;
    }

    .start{
        color: #5BB235;
    }

    .middle{
        color: #C17400;
    }

    .finish{
        color: #bf0000;
    }
</style>